import { createSlice } from '@reduxjs/toolkit'
import { logOut } from '../authentication/authenticationSlice';
import { markCaseWithoutPlate } from '../cases/thunks';
import { setClaims, setDelivery, setTerminations, setWorkshopAppointment, setDocumentation, setItv, setOvc, setSubstitutionVehicle, setFuelCard, setMarsh, setLetter } from '../currentCase/thunks';
import { regressFactoryCase } from '../caseForms/thunks';
import { getContract, getContractByCaseId,getCommentByCaseId, updateContractData, updateCase, createCase, newCase, getCustomerContractData, associateContract, getContractSimple, attachIdtProcessToCase, getContractList} from "./thunks"

const initialState = {
  contract: {
    cases: [],
    case: null,
    contractData: null,
    checkedExceptions:false
  },
  contractList: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  historyCase : null,
  loading: "idle",
  loadingPau: "idle",
  loadingList: "idle",
  error: null
}


const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    updatePauData: (state, action) => {
      state.contract.contractData = action.payload;
    },
    removeActiveHistory: (state) =>{
     state.contract.cases.forEach((e)=> {if(e.active){e.showCurrent = true}})
    },
    clearContractError: (state)=>{
      state.error = null;
      state.loading = "idle";
      state.loadingPau = "idle"
    },
    updateExceptionChecked: (state,action)=>{
      state.contract.checkedExceptions = action.payload
    },
    updateIdtProcessId: (state, action)=>{
      state.contract.case.idtProcessId = action.payload
    },
    setHistoryCase:(state, action)=>{
     state.historyCase = action.payload
    }
  },
  extraReducers: {
    [getContract.pending]: (state) => {
      state.loading = "loading";
      state.loadingPau = "loading";
      state.error = null
    },
    [getContract.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.loadingPau = "succeeded";
      state.contract = {...state.contract, ...action.payload};
      state.contract.checkedExceptions = false;
      state.contract.casePreviousState ={firstState:action.payload?.case?.caseId,stateChanged:null}
      state.historyCase = null
    },
    [getContract.rejected]:(state, action) =>
    {state.contract = initialState.contract;
    state.loading = "failed";
    state.loadingPau = "failed";
    state.error = action.error.message
    },
    [updateCase.fulfilled]: (state,action) => {
      const {historic, ...currentCase} = action.payload
      state.contract.case = currentCase
      state.contract.cases = historic
    },
    [getContractSimple.pending]: (state) => {
      state.loading = "loading";
      state.loadingPau = "loading"
      state.error = null
    },
    [getContractSimple.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.loadingPau = "succeeded"
      delete action.payload.case;
      state.historyCase = null
      state.contract = {...state.contract, ...action.payload, unassigned : true}
      state.contract.checkedExceptions = false;
    },
    [getContractSimple.rejected]:(state, action) =>{
      state.loading = "failed";
    state.loadingPau = "failed";
    state.error = action.error.message},

    [getContractByCaseId.pending]: (state) => {
      state.loading = "loading";
      state.loadingPau= "loading";
      state.error = null
    },
    [getContractByCaseId.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.loadingPau= "succeeded";
      state.historyCase = null
      state.contract = {...state.contract, ... action.payload};
      if (state.contract.unassigned) {delete state.contract.unassigned};
      state.contract.checkedExceptions = false;
    },
    [getContractByCaseId.rejected]: (state, action) => {
      state.loading = "failed";
      state.loadingPau= "failed";
      state.error = action.error.message
    },
    [createCase.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [createCase.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      const {historic, ...currentCase} = action.payload
      state.contract.case = currentCase
      state.contract.cases = historic
    },
    [createCase.rejected]: (state,action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [updateContractData.pending]: (state) => {
      state.loadingPau = "loading";
      state.error = null
    },
    [updateContractData.fulfilled]: (state, action) => {
      state.contract.contractData = action.payload
      state.loadingPau = "succeeded";
    },
    [updateContractData.rejected]: (state, action) => {
      state.loadingPau = "failed";
      state.error = action.error.message
    },
    [newCase.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [newCase.fulfilled]: (state,action) => {
      state.loading = "succeeded";
      state.contract.case = action.payload;
      if(state.contract.unassigned){delete state.contract.unassigned}
    },
    [newCase.rejected]: (state,action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getCustomerContractData.pending]: (state) => {
      state.loading = "loading";
      state.error = null
    },
    [getCustomerContractData.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.contract = action.payload;
      state.contract.checkedExceptions = false;
    },
    [getCustomerContractData.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [associateContract.pending]: (state) => {
      state.loading = "loading";
      state.error = null
    },
    [associateContract.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      delete state.contract.unassigned
      state.contract.cases = action.payload.cases
      state.contract.case.comments = action.payload.case.comments
      state.contract.case.withoutPlate = false
    },
    [associateContract.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [getCommentByCaseId.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getCommentByCaseId.fulfilled]: (state) => {
      state.loading = "succeeded";
      state.error = null;
    },
    [markCaseWithoutPlate.fulfilled]: (state,action) => {
      state.contract.case.withoutPlate = action.payload.withoutPlate
      state.contract.case.comments = action.payload.comments
      delete state.contract.case.historic
    },
    [setWorkshopAppointment.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setDocumentation.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setSubstitutionVehicle.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setTerminations.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setClaims.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setDelivery.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setOvc.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setItv.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setFuelCard.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setMarsh.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [setLetter.fulfilled]: (state,action)=>{
      state.contract.case.caseId = action.payload.caseId
      state.contract.case.state = action.payload.state
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.taxonomyLevel_1 = action.payload.taxonomyLevel_1
      state.contract.case.taxonomyLevel_2 = action.payload.taxonomyLevel_2
      state.contract.case.taxonomyLevel_3 = action.payload.taxonomyLevel_3
      state.contract.case.taxonomyLevel_4 = action.payload.taxonomyLevel_4
      state.contract.case.idtProcessId = action.payload.idtProcessId
    },
    [attachIdtProcessToCase.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      state.contract.case.idtProcessId = action.payload.idtProcessId;
      state.error = null
    },
    [regressFactoryCase.fulfilled]: (state, action)=>{
      state.contract.case.stateId = action.payload.stateId
      state.contract.case.state = action.payload.state
    },
    [getContractList.pending]: (state)=>{
      state.loadingList = "loading"
    },
    [getContractList.fulfilled]: (state, action)=>{
      state.loadingList = "succeeded";
      state.contractList = action.payload;
      state.contractList.pageIndex = action.payload.pageIndex;
      state.contractList.totalRecords = action.payload.totalRecords;
      state.contractList.totalPages = action.payload.totalPages;
      state.contractList.hasPreviousPage = action.payload.hasPreviousPage;
      state.contractList.hasNextPage = action.payload.hasNextPage
        
    },
    [getContractList.rejected]: (state, action)=>{
      state.loadingList = "failed";
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const { updatePauData, clearContractError, removeActiveHistory, updateExceptionChecked, updateIdtProcessId, setHistoryCase} = contractSlice.actions;

export default contractSlice.reducer
